import request from "@/plugins/request";
import {baseApi} from "@/api/scope";



// 新增用户
export function addDict(data) {
    // let formData = new FormData();
    // formData.append('askStr', JSON.stringify({ action: 'adddict', ...data }));
    return request.post(baseApi, { action: 'adddict', ...data });
}

export function  getDictList(data) {
    // let formData = new FormData();
    // formData.append('askStr', JSON.stringify({ action: 'getdictlist', ...data }));
    return request.post(baseApi, { action: 'getdictlist', ...data });
}

export function updateDict(data) {
    // let formData = new FormData();
    // formData.append('askStr', JSON.stringify({ action: 'updatedict', ...data }));
    return request.post(baseApi, { action: 'updatedict', ...data });
}
